// extracted by mini-css-extract-plugin
export default {"rating":"Fz-z","numberOfStars":"Gz-z","count":"Hz-z","barGraphSpacing":"Iz-z","barGraph":"Jz-z"};